"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _moment = _interopRequireDefault(require("moment"));

var _formatNumberWithThousandSeparators = _interopRequireDefault(require("../display/formatNumberWithThousandSeparators"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var makeTheDisplayMoreReadable = function makeTheDisplayMoreReadable(number) {
  return number.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',');
};

var formatSuccessActivities = function formatSuccessActivities(_ref) {
  var activities = _ref.activities;

  if (activities) {
    var climb = activities.climb,
        descent = activities.descent,
        distance = activities.distance,
        duration = activities.duration,
        points = activities.points;
    var distanceUnit = distance / 1000;
    var formattedDistance = makeTheDisplayMoreReadable(distanceUnit);

    var formattedDuration = _moment["default"].duration(duration, 'seconds')._data;

    var formattedPoints = (0, _formatNumberWithThousandSeparators["default"])(points);
    return _objectSpread({}, activities, {
      climb: climb / 1000,
      descent: descent / 1000,
      distance: formattedDistance,
      duration: formattedDuration,
      points: formattedPoints
    });
  }

  return null;
};

var _default = formatSuccessActivities;
exports["default"] = _default;
//# sourceMappingURL=formatSuccessActivities.js.map